import { createBrowserRouter, Navigate } from 'react-router-dom';
import { ApplicationNotSupported } from '@pages/fallbacks/ApplicationNotSupported';

export const router = createBrowserRouter([
  {
    path: `/`,
    element: <ApplicationNotSupported />,
  },
  {
    path: `*`,
    element: <Navigate replace to="/" />,
  },
]);
